var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOnboardingButtonTopLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 42,
    viewBox: "0 0 37 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5401 31.6189C9.94872 31.3325 7.17586 30.7211 5.71501 30.5607C2.49415 30.2383 1.66505 30.107 1.45317 31.1482C1.01366 32.3122 3.23254 33.0799 5.90769 33.9812C9.14413 34.9794 12.4841 35.6042 15.8625 35.8437C16.6714 35.8618 19.6925 35.6052 19.6949 34.2865C19.7929 32.5935 14.4932 32.2579 11.5401 31.6189Z",
    fill: "#FF8B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6732 23.5899C21.0391 22.6871 16.949 18.536 16.4027 18.046C14.3468 16.3058 12.8114 14.8561 11.9 15.6653C10.42 16.8324 14.7358 21.3973 15.8628 22.6464C16.4968 23.3208 18.5017 25.4101 19.2328 25.9719C19.5515 26.2201 21.7286 27.7577 22.5485 27.0274C23.3683 26.2971 21.926 23.9525 21.6732 23.5899Z",
    fill: "#FF8B22"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5603 16.4107C30.3163 15.1993 29.3318 11.5305 28.9338 10.2419C28.6848 9.25662 28.3788 8.28666 28.0173 7.33689C26.7462 4.44235 26.1935 3.46631 25.2304 3.78408C24.1999 4.09071 24.399 5.45628 24.836 7.71122C25.3893 11.1536 26.2445 14.5406 27.3916 17.8331C27.529 18.2077 28.8264 20.8681 29.9791 20.5257C31.2848 20.1421 30.6106 17.0166 30.5603 16.4107Z",
    fill: "#FF8B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingButtonTopLeft);
export default __webpack_public_path__ + "static/media/onboardingButtonTopLeft.b7d70734eb0aef2bb8d579fddc6f9008.svg";
export { ForwardRef as ReactComponent };